module.exports = __webpack_public_path__ + "img/五加皮.9e06ad94.jpg";